<template>
  <div class="container-planscardlist">
    <div class="mob-mg-wrap">
      <button type="button" class="gray-btn s-btn" @click="goToManagePlan">{{ t('ss_manage_subscription') }}</button>
    </div>

    <div class="wrapper-title">
      <div class="inr-left">
        <h4 class="tit-h4">{{ t('self_service_interpretation_plan') }}</h4>

        <TabsToggle :list-option-tab :active-tab="billingCycle" @tabClick="toggleBillingCycle($event)" />
      </div>

      <button type="button" class="round-b-btn line-btn" @click="goToManagePlan">{{ t('plan_setting') }}</button>
    </div>

    <div class="wrapper-plans">
      <PlanCard
        v-for="[key, value] in Object.entries(planBenefits ?? {})"
        :key="key"
        :plan="key"
        :plan-details="value"
        :plan-prices
        :billing-cycle
      >
        {{ key }}
      </PlanCard>
    </div>
  </div>
</template>

<script setup lang="ts">
import PlanCard from '@/components/domains/self-service/payment-settings/PlanCard.vue';
import TabsToggle from '@/components/shared/composite/TabsToggle.vue';
import { PlanPricing } from '@/types/components';

withDefaults(
  defineProps<{
    planBenefits?: Record<string, { language: string; price: string; pricePerChat: string[]; features: string[] }>;
    planPrices?: Record<string, PlanPricing>;
  }>(),
  {
    planBenefits: () => ({}),
    planPrices: () => ({}),
  }
);

const { t } = useI18n();
const router = useRouter();

const billingCycle = ref<'MONTHLY' | 'YEARLY'>('MONTHLY');

const listOptionTab = computed(() => [
  { label: t('self_service_tab_monthly'), value: 'MONTHLY' },
  { label: t('self_service_tab_yearly'), value: 'ANNUAL' },
]);

const toggleBillingCycle = (type) => {
  billingCycle.value = type;
};

const goToManagePlan = () => {
  router.push({ name: 'ss-plan-manage' });
};
</script>

<style scoped lang="scss">
.mob-mg-wrap {
  display: none;
  @include respond-to(mobile-landscape) {
    display: block;
  }
}
.container-planscardlist {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  scroll-margin-top: 68px;
}

.wrapper-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  .inr-left {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  @include respond-to(mobile-landscape) {
    flex-direction: column;
    justify-content: center;
    margin-bottom: 1rem;
    .inr-left {
      flex-direction: column;
      gap: $size-m;
    }
    button {
      display: none;
    }
  }
  @include respond-to(mobile-portrait) {
    width: 100%;
  }
}

.wrapper-tabs {
  display: flex;
  justify-content: space-between;
}

.wrapper-plans {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
  @media (max-width: 1540px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @include respond-to(mobile-landscape) {
    grid-template-columns: 1fr;
  }
}
</style>
